import { GARTEN_TYPEN } from "../../lib/wizard";
import type { GartenPosition } from "../../lib/wizard";
import type { Gartenprofil } from "../../hooks/useGartenprofil";

/** Schritt 2 „Garten": Flächen und Elemente, Anschrift des Pflegeobjekts, Zugang. */
export default function SchrittGarten({ g }: { g: Gartenprofil }) {
  return (
    <>
      <p className="pf-wz-einleitung">
        Garten Position für Position erfassen — Typ, Größe und Zustand. Grundlage der
        Kalkulation, einmal erfasst für alle Angebote wiederverwendbar.
      </p>
      {g.garten.length === 0 && (
        <div className="pf-empty pf-wz-abstand">Noch keine Position — unten hinzufügen.</div>
      )}
      {g.garten.map((pos, i) => (
        <GartenZeile key={i} pos={pos} onPatch={p => g.patchZeile(i, p)} onRemove={() => g.entferneZeile(i)} />
      ))}
      <button className="pf-btn is-ghost pf-wz-oben-4" onClick={g.neueZeile}>＋ Position hinzufügen</button>
      <div className="pf-card pf-wz-oben-18">
        <div className="pf-wz-titel pf-wz-unten-4">Anschrift des Pflegeobjekts</div>
        <div className="pf-wz-klein pf-wz-unten">
          Das Grundstück, das gepflegt wird — steht so im Vertrag. Kann von der
          Rechnungsanschrift abweichen.
        </div>
        <label className="pf-field">
          <span>Straße und Hausnummer</span>
          <input className="pf-input" value={g.strasse} onChange={e => g.setStrasse(e.target.value)}
            placeholder="z. B. Weimarische Straße 31" />
        </label>
        <div className="pf-grid-2 pf-wz-oben-10">
          <label className="pf-field"><span>PLZ</span>
            <input className="pf-input" value={g.plz} onChange={e => g.setPlz(e.target.value)} placeholder="01127" /></label>
          <label className="pf-field"><span>Ort</span>
            <input className="pf-input" value={g.ort} onChange={e => g.setOrt(e.target.value)} placeholder="Dresden" /></label>
        </div>
      </div>
      <label className="pf-field pf-wz-oben-16">
        <span>Zugang / Besonderheiten (gesamter Garten)</span>
        <input className="pf-input" value={g.zugang} onChange={e => g.setZugang(e.target.value)} placeholder="z. B. Schlüssel beim Nachbarn, Hund im Garten…" />
      </label>
    </>
  );
}

function GartenZeile({ pos, onPatch, onRemove }: {
  pos: GartenPosition; onPatch: (p: Partial<GartenPosition>) => void; onRemove: () => void;
}) {
  const bekannt = GARTEN_TYPEN.some(t => t.typ === pos.typ);
  const eigen = !bekannt || pos.typ === "Sonstiges";
  return (
    <div className="pf-card pf-wz-zeile">
      <div className="pf-wz-zeile-kopf">
        <div className="pf-garden">
          <label className="pf-field pf-wz-feld"><span>Typ</span>
            <select className="pf-input is-tight" value={bekannt ? pos.typ : "Sonstiges"}
              onChange={e => {
                const t = GARTEN_TYPEN.find(x => x.typ === e.target.value);
                onPatch(e.target.value === "Sonstiges"
                  ? { typ: "", einheit: pos.einheit }
                  : { typ: e.target.value, einheit: t?.einheit || pos.einheit });
              }}>
              {GARTEN_TYPEN.map(t => <option key={t.typ} value={t.typ}>{t.typ}</option>)}
            </select>
          </label>
          <label className="pf-field pf-wz-feld"><span>Größe</span>
            <input className="pf-input is-tight" inputMode="decimal" value={pos.groesse}
              onChange={e => onPatch({ groesse: e.target.value })} placeholder="z. B. 420" />
          </label>
          <label className="pf-field pf-wz-feld"><span>Einheit</span>
            <input className="pf-input is-tight" value={pos.einheit}
              onChange={e => onPatch({ einheit: e.target.value })} placeholder="m²" />
          </label>
        </div>
        <button className="pf-iconbtn" onClick={onRemove} title="Position entfernen" aria-label="Position entfernen">×</button>
      </div>
      {eigen && (
        <input className="pf-input is-tight pf-wz-oben-8" value={pos.typ}
          onChange={e => onPatch({ typ: e.target.value })} autoFocus={pos.typ === ""}
          placeholder="Eigener Typ (z. B. Kräuterbeet)…" />
      )}
      <input className="pf-input is-tight pf-wz-oben-8" value={pos.zustand}
        onChange={e => onPatch({ zustand: e.target.value })}
        placeholder="Zustandsbeschreibung / Besonderheit (z. B. stark verunkrautet, Hanglage)" />
    </div>
  );
}
